/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceGroupNotificationsQueryVariables = Types.Exact<{
  clientApplicationId: Types.Scalars['UUID']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeResolved?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ResourceGroupNotificationsQuery = { __typename: 'Query', resourceGroupNotifications?: { __typename: 'NotificationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'NotificationTypeEdge', node?: { __typename: 'NotificationType', id: string, notificationType?: Types.NotificationEnum | null, createdAt: string, resolvedAt?: string | null, acknowledgedAt?: string | null, ignoreUntil?: string | null, application?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, vendorName?: string | null, productDomainName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', primaryApplication?: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, vendorName?: string | null, productDomainName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } } } | null } | null } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string, email: string } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };



export const ResourceGroupNotificationsDocument = `
    query ResourceGroupNotifications($clientApplicationId: UUID!, $first: Int, $offset: Int, $sortBy: String, $includeResolved: Boolean) {
  resourceGroupNotifications(
    clientApplicationId: $clientApplicationId
    first: $first
    offset: $offset
    sortBy: $sortBy
    includeResolved: $includeResolved
  ) {
    edges {
      node {
        id
        notificationType
        createdAt
        application {
          id
          resource {
            id
            productName
            vendorName
            productDomainName
            publicResource {
              signedLogoUrl
            }
          }
          resourceGroupApplications {
            primaryApplication {
              id
              resource {
                id
                productName
                vendorName
                productDomainName
                publicResource {
                  signedLogoUrl
                }
              }
            }
          }
        }
        employee {
          id
          name
          email
        }
        resolvedAt
        acknowledgedAt
        ignoreUntil
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

export const useResourceGroupNotificationsQuery = <
      TData = ResourceGroupNotificationsQuery,
      TError = unknown
    >(
      variables: ResourceGroupNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<ResourceGroupNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceGroupNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceGroupNotificationsQuery, TError, TData>(
      {
    queryKey: ['ResourceGroupNotifications', variables],
    queryFn: fetcher<ResourceGroupNotificationsQuery, ResourceGroupNotificationsQueryVariables>(ResourceGroupNotificationsDocument, variables),
    ...options
  }
    )};

useResourceGroupNotificationsQuery.getKey = (variables: ResourceGroupNotificationsQueryVariables) => ['ResourceGroupNotifications', variables];

export const useInfiniteResourceGroupNotificationsQuery = <
      TData = InfiniteData<ResourceGroupNotificationsQuery>,
      TError = unknown
    >(
      variables: ResourceGroupNotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceGroupNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceGroupNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceGroupNotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ResourceGroupNotifications.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceGroupNotificationsQuery, ResourceGroupNotificationsQueryVariables>(ResourceGroupNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceGroupNotificationsQuery.getKey = (variables: ResourceGroupNotificationsQueryVariables) => ['ResourceGroupNotifications.infinite', variables];


useResourceGroupNotificationsQuery.fetcher = (variables: ResourceGroupNotificationsQueryVariables) => fetcher<ResourceGroupNotificationsQuery, ResourceGroupNotificationsQueryVariables>(ResourceGroupNotificationsDocument, variables);
